// eslint-disable-next-line no-restricted-imports
import createAuthClient from '@studio/auth';

/* global CUSTOMER_API_URL, AUTH_APP_URL, CRX_ID */
export default createAuthClient(CUSTOMER_API_URL, AUTH_APP_URL, CRX_ID);
